// @owners { team: patients }
import { Body, Column, H1, MdPadding } from '@alto/design-system';
import React from 'react';

type Props = {
  readonly email: string;
};

export const StayInTouch = ({ email }: Props) => {
  return (
    <MdPadding>
      <Column gap="LG">
        <H1 center>We'd like to stay in touch!</H1>
        <Body
          center
          fontFamily="semibold"
        >
          Hi <strong>{email}</strong>, uncheck an option to remove yourself from a specific mailing list.
        </Body>
      </Column>
    </MdPadding>
  );
};
